"use client";

import { useEffect } from "react";
import clsx from "clsx";
import styles from "./STModal.module.css";
export const STModal = ({
    isOpen, onClose, title, children, isNotFooter, modalBodyClassName
}) => {
    // Close on ESC key
        useEffect(() => {
            const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
            };
            document.addEventListener("keydown", handleEsc);
            return () => document.removeEventListener("keydown", handleEsc);
        }, [onClose]);

        // Prevent background scroll
        useEffect(() => {
            if (isOpen) {
            document.body.style.overflow = "hidden";
            } else {
            document.body.style.overflow = "auto";
            }
        }, [isOpen]);

        if (!isOpen) return null;

    return(
        <>
            <div className={styles.overlay}>
      
                {/* Backdrop */}
                <div className={styles.backdrop} onClick={onClose}></div>

                {/* Modal */}
                <div className={styles.container}>
                    
                    {/* Header */}
                    <div className={styles.header}>
                    <h2 className={styles.title}>{title}</h2>
                    <button onClick={onClose} className={styles.close}>
                        ×
                    </button>
                    </div>

                    {/* Body */}
                    <div className={clsx(styles.body, modalBodyClassName)}>
                    {children}
                    </div>

                    {/* Footer */}
                    {isNotFooter ? ""
                     : <div className={styles.footer}>
                        <button onClick={onClose} className={styles.btnSecondary}>
                            Cancel
                        </button>
                        <button className={styles.btnPrimary}>
                            Confirm
                        </button>
                    </div>
                    }

                </div>
            </div>
        </>
    )
}